export function relationEnterpriseConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 200,
    column: [{
        label: "关联企业名称",
        prop: "relationName",
        width: 200,
        span: 14,
        formslot: true,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "关联类型",
        prop: "relationType",
        type: "select",
        span: 14,
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=relation_type",
        props: {
          label: "dictValue",
          value: "dictKey",
        },
        dataType: "number",
        rules: [{
          required: true,
          message: "请选择关联类型",
          trigger: "blur",
        }, ]
      },
      {
        label: "备注",
        type: 'textarea',
        prop: "remark",
        span: 14

      }

    ]
  }
}

export function contactsConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 200,
    column: [{
        label: "姓名",
        prop: "contactName",
        width: 140,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "职务",
        prop: "contactDuty",


      }, {
        label: "单位电话",
        prop: "contactCompanyphone",


      }, {
        label: "手机号码",
        prop: "contactMobilephone",
      }, {
        label: "微信号",
        prop: "contactWechat",
      }, {
        label: "是否法定代表人",
        prop: "isRepresent",
        type: "radio",
        span: 12,
        width: 160,
        value: 1,
        dicData: [{
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },

        ],

      }, {
        label: "是否重要联系人",
        prop: "isImportant",
        type: "radio",
        span: 12,
        width: 160,

        value: 1,
        dicData: [{
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },

        ],

      }, {
        label: "固定电话",
        prop: "contactPhone",
      },
      {

        label: "邮箱",
        prop: "email",

      }

    ]
  }
}

export function bankAccountConfig() {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: false,
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    labelWidth: 200,
    column: [{
        label: "银行户名",
        prop: "bankAccountName",

        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "银行名称",
        prop: "bankName",

        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "银行开户行",
        prop: "bankOpenName",

        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "银行账号",
        prop: "bankNo",

        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],

      }, {
        label: "是否为默认账户",
        prop: "isDefault",
        type: "radio",
        span: 12,

        value: 1,
        dicData: [{
            label: "是",
            value: 1,
          },
          {
            label: "否",
            value: 0,
          },

        ],

      },
      {
        label: "备注",
        type: 'textarea',
        prop: "remarks",
        span: 24

      }

    ]
  }
}

import {
  isvalidatemobile
} from "@/util/validate";
const isIdCard = (rule, value, callback) => {
  if (value && value.length != 18) {
    callback(new Error("号码应为18位数"));
  } else {
    callback();
  }
};
const validatePhone = (rule, value, callback) => {
  if (isvalidatemobile(value)[0]) {
    callback(new Error(isvalidatemobile(value)[1]));
  } else {
    callback();
  }
};
export function organInformationConfig() {
  return {
    labelWidth: 200,
    emptyBtn: false,
    submitBtn: false,
    column: [{
      label: "客户名称",
      prop: "custName",
      disabled: true,
      rules: [{
        required: true,
        message: "请输入客户名称",
        trigger: "blur",
      }, ],
    }, {
      label: "客户简称",
      prop: "custShortName",
      disabled: true,
      rules: [{
        required: true,
        message: "请输入客户简称",
        trigger: "blur",
      }, ],
    }, {
      label: "客户编码",
      prop: "custNo",
      disabled: true,
      rules: [{
        required: true,
        message: "请输入客户编码",
        trigger: "blur",
      }, ],
    }, {
      label: "客户类型",
      prop: "custType",
      disabled: true,
      type: "select",
      filterable: "true",
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_type_rzzl",
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      dicQuery: {},
      rules: [{
        required: true,
        message: "请选择客户类型",
        trigger: "blur",
      }, ],
    }, {
      label: "客户类别",
      prop: "custCategory",
      disabled: true,
      type: "select",
      filterable: "true",
      dataType: 'string',
      dicData: [{
          label: "个人客户",
          value: "1",
        },
        {
          label: "机构客户",
          value: "2",
        },
      ],
      rules: [{
        required: true,
        message: "请选择客户类别",
        trigger: "blur",
      }, ],
    }, {
      label: "客户来源",
      prop: "custSource",
      disabled: true,
      type: "select",
      filterable: "true",
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_source",
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      rules: [{
        required: true,
        message: "请选择客户来源",
        trigger: "blur",
      }, ],
    }, {
      label: "客户分类",
      prop: "custClassify",
      disabled: true,
      type: "select",
      filterable: "true",
      dataType: "number",
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=cust_classify",
      props: {
        label: "dictValue",
        value: "dictKey",
      },

    }, {
      label: "是否上市及其关联公司",
      prop: "isGoPublic",
      type: "radio",
      disabled: true,
      dicData: [{
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      value: 0,

    }, {
      label: "是否新三板企业",
      prop: "isNewThreeCompay",
      type: "radio",
      disabled: true,
      dicData: [{
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      value: 0,

    }, {
      label: "是否瞪羚企业",
      prop: "isGazelleCompany",
      type: "radio",
      disabled: true,
      dicData: [{
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      value: 0,

    }, {
      label: "是否国有企业",
      prop: "isGovCompany",
      type: "radio",
      disabled: true,
      dicData: [{
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      value: 0,

    }, {
      label: "是否省级专精特新企业",
      prop: "isProvinceCompany",
      type: "radio",
      disabled: true,
      dicData: [{
          label: "否",
          value: 0
        },
        {
          label: "是",
          value: 1
        }
      ],
      value: 0,

    }, {
      label: '客户性质',
      prop: 'custAttribute',
      disabled: true,
      type: 'checkbox',
      span: 24,
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=bl_cust_attribute",
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      rules: [{
        required: true,
        message: "请选择客户性质",
        trigger: "blur"
      }]
    }, {
      label: "所属行业",
      prop: "industry",
      type: "cascader",
      disabled: true,
      dicUrl: "/api/blade-system/dict-biz/industryType",
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      span: 24,
    }, {
      label: "主营业务",
      prop: "majorBusiness",
      disabled: true,

    }, {
      label: "经营范围",
      prop: "businessScope",
      disabled: true,

    }, {
      label: "企业类型",
      prop: "enterpriseType",
      disabled: true,
      type: "select",
      filterable: "true",
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=enterprise_type",
      props: {
        label: "dictValue",
        value: "dictKey",
      },

    }, {
      label: "企业规模",
      prop: "enterpriseScale",
      disabled: true,
      type: "select",
      filterable: "true",
      dicUrl: "/api/blade-system/dict-biz/dictionary?code=enterprise_scale",
      props: {
        label: "dictValue",
        value: "dictKey",
      },
      rules: [{
        required: true,
        message: "请选择企业规模",
        trigger: "blur",
      }, ],
    }, {
      label: "统一社会信用代码",
      prop: "unifiedSocialCreditCode",
      labelslot: true,
      disabled: true,
      // rules: [{
      //     required: true,
      //     message: "请输入统一社会信用代码",
      //     trigger: "blur",
      //   },
      //   {
      //     validator: isIdCard,
      //     trigger: "blur"
      //   },
      // ],
    }, {
      label: "注册资本（万元）",
      prop: "registeredCapital",
      disabled: true,

    }, {
      label: "成立时间",
      prop: "fundingTime",
      disabled: true,
      type: "date",
      format: "yyyy-MM-dd",
      valueFormat: "yyyy-MM-dd",
    }, {
      label: "法定代表人",
      prop: "representative",
      disabled: true,
      rules: [{
          required: true,
          message: "请输入法定代表人",
          trigger: "blur",
        },

      ],
    }, {
      label: "联系电话",
      prop: "contactNumber",
      disabled: true,
      placeholder: "请输入联系电话",

      rules: [],
    }, {
      label: "网址",
      prop: "website",
      disabled: true,
      placeholder: "请输入网址",


    }, {
      label: "注册地址",
      prop: "zcdz",
      disabled: true,
      placeholder: "请输入注册地址",
      formslot: true,
      span: 24,

    }, {
      label: "办公地址",
      prop: "bgdz",
      disabled: true,
      placeholder: "请输入办公地址",
      formslot: true,
      span: 24,

    }, {
      label: '资信情况',
      type: 'textarea',
      disabled: true,
      span: 24,
      minRows: 2,
      prop: 'financialStanding',

    }, {
      label: '诉讼情况',
      type: 'textarea',
      disabled: true,
      span: 24,
      minRows: 2,
      prop: 'litigationCases',

    }, {
      label: '股权结构',
      type: 'textarea',
      disabled: true,
      span: 24,
      minRows: 2,
      prop: 'equityStructure',

    }, {
      label: '其他',
      type: 'textarea',
      disabled: true,
      span: 24,
      minRows: 2,
      prop: 'other',

    }, {
      label: '备注',
      type: 'textarea',
      disabled: true,
      span: 24,
      minRows: 2,
      prop: 'remarks',

    }]
  }
}

export function invoiceInformationConfig() {
  return {
    labelWidth: 200,
    emptyBtn: false,
    submitBtn: false,
    column: [{
      label: "纳税人识别号",
      prop: "unifiedSocialCreditCode",
      disabled: true,
      rules: [{
          required: true,
          message: "请输入纳税人识别号",
          trigger: "blur",
        },
        // {
        //   validator: isIdCard,
        //   trigger: "blur"
        // },
      ],
    }, {
      label: "客户名称",
      prop: "custName",
      disabled: true,
      rules: [{
        required: true,
        message: "请输入客户名称",
        trigger: "blur",
      }, ],
    }, {
      label: "开户行",
      prop: "taxpayerBankName",
      disabled: true,
      formslot:true,
      rules: [{
        required: true,
        message: "请输入开户行",
        trigger: "blur",
      }, ],
    }, {
      label: "银行账号",
      prop: "taxpayerBankno",
      disabled: true,
      rules: [{
        required: true,
        message: "请输入银行账号",
        trigger: "blur",
      }, ],
    }, {
      label: "联系电话",
      prop: "taxpayerPhone",
      disabled: true,
      placeholder: "请输入联系电话",


    }, {
      label: "注册地址",
      prop: "zcdz",
      disabled: true,
      placeholder: "请输入注册地址",
      formslot: true,
      span: 24

    }]
  }
}
